import { useCallback } from 'react';

import styles from './style.module.css';

// A search box over a list already on screen: it filters as the person
// types, so there is nothing to submit. The label is for assistive
// technology; the placeholder says what to type.
export function SearchField({ id, label, placeholder, value, onChange }) {
  const onInput = useCallback(function({ currentTarget }) {
    onChange(currentTarget.value);
  }, [ onChange ]);

  return (
    <div className={ styles.search }>
      <label className={ styles.label } htmlFor={ id }>{ label }</label>

      <input id={ id } className={ styles.input } type='search' placeholder={ placeholder } value={ value } onChange={ onInput }/>
    </div>
  );
}
